var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.2f3956ece9336b2c84524fea4cca51f6.svg#m';
                    var viewUrl = 'sprites.2f3956ece9336b2c84524fea4cca51f6.svg#view-m';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 31 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };